// const faqData = [
//     {
//         id:"faq-0",
//         question:"Why should I choose LANDKING trucks?",
//         answer:"LANDKING trucks combine proven engineering, modern technology, and cost-efficient operation, offering businesses reliable performance, long-term durability, and strong value without compromising on quality or support."
//     },
//     {
//         id: "faq-1",
//         question: "Who is the authorized dealer of LANDKING trucks in Saudi Arabia?",
//         answer:
//             "BTATC (Bawabat Altawrid Alalamiya for Trading Company), is the authorized dealer of LANDKING trucks in the Kingdom of Saudi Arabia, providing sales, service, and support."
//     },
//     {
//         id: "faq-2",
//         question: "Who manufactures LANDKING trucks?",
//         answer:
//             "LANDKING trucks are manufactured by Weichai New Energy Commercial Vehicle, part of the globally recognized Weichai Group."
//     },
//     {
//         id: "faq-3",
//         question: "What types of LANDKING trucks are available?",
//         answer:
//             "LANDKING offers a range of light and medium-duty commercial trucks designed for logistics, transportation, and business operations across various payload requirements."
//     },
//     {
//         id: "faq-4",
//         question: "Are multiple variants available for each model?",
//         answer: "Yes, LANDKING trucks are available in multiple variants with different specifications, payload capacities, and configurations to suit diverse business needs."
//     },
//     {
//         id: "faq-5",
//         question: "Can specifications differ from what is shown on the website?",
//         answer: "Yes. Specifications, features, and visuals shown on the website are indicative and may change. Final specifications are confirmed at the time of order or purchase."
//     },
//     {
//         id: "faq-6",
//         question: "Are prices mentioned on the website final?",
//         answer: "No. Any pricing shown or discussed online is indicative. Final pricing depends on variant selection, configuration, availability, and applicable terms at the time of purchase."
//     },
//     {
//         id: "faq-7",
//         question: "Does the website allow online purchasing?",
//         answer: "Currently, the website is intended for product information and inquiries. Purchases are completed through official BTATC sales channels."
//     },
//     {
//         id: "faq-8",
//         question: "How can I request a quotation?",
//         answer: "You can submit an inquiry through the website or contact BTATC directly. A representative will assist you with a detailed quotation."
//     },
//     {
//         id: "faq-9",
//         question: "Do you offer after-sales service and support?",
//         answer: "Yes. BTATC provides authorized after-sales service, maintenance support, and genuine spare parts for LANDKING trucks in Saudi Arabia."
//     },
//     {
//         id: "faq-10",
//         question: "Are service plans available?",
//         answer: "Yes. Kilometer-based service plans are available, offering structured maintenance with transparent pricing."
//     },
//     {
//         id: "faq-11",
//         question: "Are spare parts easily available?",
//         answer: "Genuine LANDKING spare parts are supplied through authorized BTATC channels to ensure reliability and long-term performance."
//     },
//     {
//         id: "faq-12",
//         question: "Do LANDKING trucks come with a warranty?",
//         answer: "Yes. Warranty terms are provided as per manufacturer and dealer policies and will be clearly explained at the time of purchase."
//     },
//     {
//         id: "faq-13",
//         question: "Are LANDKING trucks suitable for Saudi road and climate conditions?",
//         answer: "Yes. LANDKING trucks are engineered for demanding operating environments, including high temperatures and heavy-duty commercial usage."
//     },
//     {
//         id: "faq-14",
//         question: "Do LANDKING trucks include modern technology features?",
//         answer: "Yes. Depending on the variant, LANDKING trucks offer features such as touchscreen displays, rear-view cameras, safety systems, and driver-focused cabin technology."
//     },
//     {
//         id: "faq-15",
//         question: "Can features vary by variant?",
//         answer: "Yes. Features may differ across variants. Customers are advised to confirm feature availability with the sales team."
//     },
//     {
//         id: "faq-16",
//         question: "Is my information safe when I submit an inquiry?",
//         answer: "Yes. All personal data is handled in accordance with Saudi Arabia’s Personal Data Protection Law (PDPL). Please refer to our Privacy Policy for details."
//     },
//     {
//         id: "faq-17",
//         question: "Does submitting an inquiry create a purchase obligation?",
//         answer: "No. Submitting an inquiry does not create any contractual or financial obligation for either party."
//     },
//     {
//         id: "faq-18",
//         question: "Can the website content be relied upon as a legal offer?",
//         answer: "No. Website content is for informational purposes only and does not constitute a legal offer, warranty, or binding commitment."
//     },
//     {
//         id: "faq-19",
//         question: "How can I contact BTATC?",
//         answer: "You can reach BTATC through the contact details provided on the website or by submitting an inquiry form."
//     },
//     {
//         id: "faq-20",
//         question: "Can I visit a LANDKING showroom or service location?",
//         answer: "Yes. Authorized locations are listed on the website's our location page, or you may contact BTATC to find the nearest facility."
//     },
// ];

// export default faqData;




const faqData = [
  {
    id: "faq-0",
    qKey: "faq.items.0.q",
    aKey: "faq.items.0.a"
  },
  {
    id: "faq-1",
    qKey: "faq.items.1.q",
    aKey: "faq.items.1.a"
  },
  {
    id: "faq-2",
    qKey: "faq.items.2.q",
    aKey: "faq.items.2.a"
  },
  {
    id: "faq-3",
    qKey: "faq.items.3.q",
    aKey: "faq.items.3.a"
  },
  {
    id: "faq-4",
    qKey: "faq.items.4.q",
    aKey: "faq.items.4.a"
  },
  {
    id: "faq-5",
    qKey: "faq.items.5.q",
    aKey: "faq.items.5.a"
  },
  {
    id: "faq-6",
    qKey: "faq.items.6.q",
    aKey: "faq.items.6.a"
  },
  {
    id: "faq-7",
    qKey: "faq.items.7.q",
    aKey: "faq.items.7.a"
  },
  {
    id: "faq-8",
    qKey: "faq.items.8.q",
    aKey: "faq.items.8.a"
  },
  {
    id: "faq-9",
    qKey: "faq.items.9.q",
    aKey: "faq.items.9.a"
  },
  {
    id: "faq-10",
    qKey: "faq.items.10.q",
    aKey: "faq.items.10.a"
  },
  {
    id: "faq-11",
    qKey: "faq.items.11.q",
    aKey: "faq.items.11.a"
  },
  {
    id: "faq-12",
    qKey: "faq.items.12.q",
    aKey: "faq.items.12.a"
  },
  {
    id: "faq-13",
    qKey: "faq.items.13.q",
    aKey: "faq.items.13.a"
  },
  {
    id: "faq-14",
    qKey: "faq.items.14.q",
    aKey: "faq.items.14.a"
  },
  {
    id: "faq-15",
    qKey: "faq.items.15.q",
    aKey: "faq.items.15.a"
  },
  {
    id: "faq-16",
    qKey: "faq.items.16.q",
    aKey: "faq.items.16.a"
  },
  {
    id: "faq-17",
    qKey: "faq.items.17.q",
    aKey: "faq.items.17.a"
  },
  {
    id: "faq-18",
    qKey: "faq.items.18.q",
    aKey: "faq.items.18.a"
  },
  {
    id: "faq-19",
    qKey: "faq.items.19.q",
    aKey: "faq.items.19.a"
  },
  {
    id: "faq-20",
    qKey: "faq.items.20.q",
    aKey: "faq.items.20.a"
  },

];

export default faqData;